import { useEffect, useRef } from 'react';
import api from '../../../lib/api';
import { getVideoSeconds } from '../../../lib/videoDuration';

const needsDuration = (l) => (l.type || 'video') === 'video' && !l.duration_sec && (l.youtube || l.video_url);

// Fills in missing video lengths for existing lessons, one at a time.
export const useDurationBackfill = (courseId, lessons, setLessons) => {
  const tried = useRef(new Set());
  useEffect(() => {
    const todo = lessons.filter(l => needsDuration(l) && !tried.current.has(l.id));
    if (!courseId || !todo.length) return;
    todo.forEach(l => tried.current.add(l.id));
    (async () => {
      for (const l of todo) {
        const secs = await getVideoSeconds({ url: l.video_url, youtube: l.youtube });
        if (!secs) continue;
        const fd = new FormData();
        fd.append('duration_sec', String(secs));
        try {
          await api.patch(`/courses/${courseId}/lessons/${l.id}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
          setLessons(ls => ls.map(x => (x.id === l.id ? { ...x, duration_sec: secs, duration_min: Math.round(secs / 60) } : x)));
        } catch (e) { /* retried next time the editor opens */ }
      }
    })();
  }, [courseId, lessons, setLessons]);
};
